export const SITE_NAME = 'PartyNestt';
export const WHATSAPP_NUMBER = '+916377302573';
export const WHATSAPP_DISPLAY = '+91 6377302573';
export const WHATSAPP_URL = 'https://wa.me/916377302573';
export const CONTACT_EMAIL = 'info@partynestt.com';
export const ADDRESS = 'Umang Aslali, Aslali, Ahmedabad, Gujarat 382427';
